import MonacoEditor from '@monaco-editor/react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import React from 'react';

type CsvEditorDialogProps = {
  open: boolean;
  value: string;
  onClose: () => void;
  onChange: (value: string) => void;
  onSubmit: () => void;
};

export function CsvEditorDialog({
  open,
  value,
  onClose,
  onChange,
  onSubmit,
}: CsvEditorDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableEscapeKeyDown
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          width: '90vw',
          height: '80vh',
        },
      }}
    >
      <DialogTitle>CSV Editor</DialogTitle>
      <DialogContent sx={{ flex: 1, p: 0 }}>
        <MonacoEditor
          height="100%"
          language="csv"
          theme="vs-dark"
          value={value}
          onChange={(value) => onChange(value || '')}
          options={{
            minimap: { enabled: false },
            fontSize: 14,
            wordWrap: 'on',
            automaticLayout: true,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSubmit} variant="outlined">
          Load
        </Button>
      </DialogActions>
    </Dialog>
  );
}
